import axios from 'axios'

const CustomerMemoService = {
  async get (params = {}) {
    return axios.get('accountant/customer-memos', { params })
  },

  async exports (params = {}) {
    return axios.get('accountant/exports/customer-memos', { params })
  },

  async show (id) {
    return axios.get(`accountant/customer-memos/${id}`)
  },

  async post (params = {}) {
    return axios.post('accountant/customer-memos', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`accountant/customer-memos/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`accountant/customer-memos/${data.id}`, { data })
  }
}

export default CustomerMemoService
